import { fromJS, List } from 'immutable';
import isArrayLike from 'lodash/isArrayLike';
import keyBy from 'lodash/keyBy';
import map from 'lodash/map';
import { ACTIVE_QUIZ_CHANGE, ADD_QUIZZES, ASSOCIATE_QUIZ_ENTRIES, ASSOCIATE_QUIZ_ANALYSIS, ASSOCIATE_ITEM_ANALYSES, DISASSOCIATE_QUIZ_ENTRY } from '@instructure/quiz-common';
var assocQuizEntry = function assocQuizEntry(state, quizId, quizEntries) {
  var quizEntryIds = List(map(quizEntries, 'id'));
  return state.setIn([quizId, 'quizEntries'], quizEntryIds);
};
var dissocQuizEntry = function dissocQuizEntry(state, quizId, quizEntryId) {
  return state.updateIn([quizId, 'quizEntries'], function (quizEntriesList) {
    return quizEntriesList.filter(function (item) {
      return item !== quizEntryId;
    });
  });
};
var assocItemAnalysis = function assocItemAnalysis(state, quizId, itemAnalyses) {
  var itemAnalysisIds = List(map(itemAnalyses, 'item_id'));
  return state.setIn([quizId, 'itemAnalyses'], itemAnalysisIds);
};
var assocQuizAnalysis = function assocQuizAnalysis(state, quizId, quizAnalysis) {
  return state.setIn([quizId, 'quizAnalysis'], quizAnalysis.quiz_id);
};
var addQuizzes = function addQuizzes(state, quizzes) {
  var quizHash = isArrayLike(quizzes) ? keyBy(quizzes, 'id') : quizzes;
  return state.mergeDeep(fromJS(quizHash));
};
var defaultState = fromJS({});
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case DISASSOCIATE_QUIZ_ENTRY:
      return dissocQuizEntry(state, "".concat(action.payload.quizId), action.payload.quizEntryId);
    case ASSOCIATE_QUIZ_ENTRIES:
      return assocQuizEntry(state, "".concat(action.payload.quizId), action.payload.quizEntries);
    case ASSOCIATE_ITEM_ANALYSES:
      return assocItemAnalysis(state, "".concat(action.payload.quizId), action.payload.itemAnalyses);
    case ASSOCIATE_QUIZ_ANALYSIS:
      return assocQuizAnalysis(state, "".concat(action.payload.quizId), action.payload.quizAnalysis);
    case ADD_QUIZZES:
      return addQuizzes(state, action.payload);
    case ACTIVE_QUIZ_CHANGE:
      return state.set('activeQuizId', action.payload);
    default:
      return state;
  }
});